<template>
  <section>
    <h1>Overview of Battery and Inverter</h1>
    <hr class="h1-underline"/>

    <div class="image-wrapper">
      <div class="has-text-centered">
        <img
          src="https://camas.app/resources/static/images/images/image__e280ca7b1f8b179d95cd3fa25901c58d.png"/>
        <div class="helper">Mitrex Battery</div>
      </div>
      <div class="has-text-centered">
        <img src="https://camas.app/resources/static/images/images/image__1c8c7e17d829e050889021157d1c93bf.jpg"/>
        <div class="helper">Mitrex Inverter</div>
      </div>
    </div>

    <p>
      The battery and inverter, as well as all wiring and conduits needed for the
      Mitrex SolaRail&trade; and solar cladding, are included in the pricing this proposal. 
      The cost of the battery, inverter, wiring, and conduits is 
      {{ +amount - +discount | currency }}. View the table below for the cost breakdown.
    </p>

    <table class="table is-fullwidth mt-3">
      <thead>
        <tr class="battery__header">
          <th>
            Definition
          </th>
          <th>
            Costs
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="battery__value">
          <td>
            <div>
              Solar System
            </div>
            <div class="help">
              Includes battery, inverter, wiring, connections, conduits
            </div>
          </td>
          <td>
            {{ amount | currency }}
          </td>
        </tr>
        <tr
          class="battery__mitrex-credit" 
          v-if="discount && discount > 0">
          <td>
            <div>
              Mitrex Credit
            </div>
            <div class="help">
              to be paid back over the course of the energy contract
            </div>
          </td>
          <td>
            -{{ discount | currency }}
          </td>
        </tr>
      </tbody>
      <tfoot 
        class="battery__price" 
        v-if="discount && discount > 0">
        <tr>
          <td>
            Total up-front costs
          </td>
          <td>
            {{ +amount - +discount | currency }}
          </td>
        </tr>
      </tfoot>
    </table>

    <p class="help mt-2">
      <i>Disclaimer: the visualizations of the battery and inverter above do
      not represent the exact products. The products provided in real life can
      differ slightly from the above created visualisation.</i>
    </p>
  </section>
</template>

<script>
export default {
  props: {
    amount: {
      type: [Number, String],
      default: 1500000
    },
    discount: {
      type: [Number, String],
      default: 1500000
    },
    hasMpaPrice: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  color: #F16635;
  margin: 1em 0em;
  img {
    max-width: 220px;
    max-height: 220px;
  }
}

.battery {
  &__header {
    text-transform: uppercase;
    color: #0E4E74;
  }
  &__value {
    background: #F1F2F2;
  }
  &__mitrex-credit {
    background: #0E4E74;
    color: #fff;
  }
  &__price {
    background: #E6ECF2;
  }
}
</style>
